<template>
  <div>
    <EligibilityBaseDialog
      ref="dialogEligibilityLandLord"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="{ cancel, isShow, title }">
        <Eligibility
          v-if="isShow"
          :handleNextData="{}"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibilityLandLord"
          :dialogLoading="$refs.dialogLoading"
          :dialogNotMet="$refs.dialogNotMetLandLord"
          :isShow="isShow"
          :title="title"
          :listEligibility="LANDLORD_ELIGIBILITY"
          :inforMsg="LANDLORD_ELIGIBILITY_INFO_MSG"
          :customHandleConfirmEligibility="true"
          :continuationUrl="continuationUrl"
          @confirmEligibility="
            $emit(
              'onConfirmEligibility',
              PRODUCT.LandLord,
              LANDLORD_TYPE.LandLord
            )
          "
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog
      ref="dialogEligibilityLandLordCompany"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="{ cancel, isShow, title }">
        <Eligibility
          v-if="isShow"
          :handleNextData="{}"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibilityLandLordCompany"
          :dialogLoading="$refs.dialogLoading"
          :dialogNotMet="$refs.dialogNotMetCompany"
          :isShow="isShow"
          :title="title"
          :listEligibility="LANDLORD_COMPANY_ELIGIBILITY"
          :inforMsg="LANDLORD_ELIGIBILITY_INFO_MSG"
          :customHandleConfirmEligibility="true"
          :continuationUrl="continuationUrl"
          @confirmEligibility="
            $emit(
              'onConfirmEligibility',
              PRODUCT.LandLord,
              LANDLORD_TYPE.Company
            )
          "
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog ref="dialogLoading" :windowClass="'confirm-dialog'">
      <template v-slot:content="{ title }">
        <EligibilityLoading :title="title" />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog
      ref="dialogNotMetLandLord"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="{ cancel, isShow, title }">
        <EligibilityNotMet
          v-if="isShow"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibilityLandLord"
          :dialogNotMet="$refs.dialogNotMetLandLord"
          :isShow="isShow"
          :title="title"
          :confirmText="'Return to homepage'"
          :isSaveAndExit="false"
          :isSelfserve="true"
          :emitEventToParent="true"
          @confirmEligibilityNotMet="$emit('confirmEligibilityNotMet')"
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog
      ref="dialogNotMetCompany"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="{ cancel, isShow, title }">
        <EligibilityNotMet
          v-if="isShow"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibilityLandLordCompany"
          :dialogNotMet="$refs.dialogNotMetCompany"
          :isShow="isShow"
          :title="title"
          :confirmText="'Return to homepage'"
          :isSaveAndExit="false"
          :isSelfserve="true"
          :emitEventToParent="true"
          @confirmEligibilityNotMet="$emit('confirmEligibilityNotMet')"
        />
      </template>
    </EligibilityBaseDialog>
  </div>
</template>

<script>
import Eligibility from "@/views/Dialog/Eligibility.vue";
import EligibilityBaseDialog from "@/components/EligibilityBaseDialog";
import EligibilityLoading from "@/views/Dialog/EligibilityLoading";
import EligibilityNotMet from "@/views/Dialog/EligibilityNotMet.vue";
import { PRODUCT, LANDLORD_TYPE } from "@/constants/common.constants";
import {
  LANDLORD_ADD_ONS,
  LANDLORD_INSURERS,
  LANDLORD_POLICY_DOCUMENT,
  LANDLORD_TYPE_INSURANCES,
  LANDLORD_TYPE_OF_INSURANCE,
} from "@/constants/d2c-landing-page.constants.js";
import {
  LANDLORD_ELIGIBILITY_INFO_MSG,
  LANDLORD_COMPANY_ELIGIBILITY,
  LANDLORD_ELIGIBILITY,
} from "@/constants/eligibility.constants";
export default {
  name: "EligibilityDialogWrapper",
  components: {
    Eligibility,
    EligibilityBaseDialog,
    EligibilityLoading,
    EligibilityNotMet,
  },
  props: {
    continuationUrl: String,
  },
  data() {
    return {
      title: "LANDLORDS INSURANCE",
      whatInsuranceCoverTitle: "What does Landlord’s Insurance cover?",
      LANDLORD_TYPE_OF_INSURANCE,
      LANDLORD_TYPE_INSURANCES,
      LANDLORD_POLICY_DOCUMENT,
      LANDLORD_INSURERS,
      LANDLORD_ADD_ONS,
      LANDLORD_ELIGIBILITY_INFO_MSG,
      LANDLORD_ELIGIBILITY,
      LANDLORD_COMPANY_ELIGIBILITY,
      PRODUCT: PRODUCT,
      LANDLORD_TYPE: LANDLORD_TYPE,
    };
  },
};
</script>

<style lang="scss" scoped></style>
